import Layout from "@/components/Layout/Layout";
import MobileLayout from "@/components/Layout/MobileLayout";
import Loader from "@/components/CustomUiComponents/Loader";
import { useMyCampaigns } from "@/services/campaign";
import useMobile from "@/lib/useMobile";
import useUser from "@/lib/useUser";
import CampaignHeader from "@/components/NewCampaignViews/CampaignHeader";
import MobileCampaignHeader from "@/components/NewCampaignViews/MobileCampaignHeader";
import CampaignAssistant from "@/components/Campaign/CampaignAssistant";

export default function Home() {
  const { data } = useMyCampaigns();
  const { user } = useUser();
  const { isMobile } = useMobile();
  const favoriteId = user?.favoriteCampaignId;
  const campaign =
    (favoriteId && data?.find((c) => c.id === favoriteId)) ||
    data?.find((c) => c.song?.spotifyId && c.artist?.image) ||
    data?.find(() => true);
  if (data?.length === 0)
    return (
      <Layout title="" page="dashboard">
        <div></div>
      </Layout>
    );
  if (!campaign) {
    return (
      <div id="root-portal">
        <Layout title="" page="dashboard">
          <Loader full={true} />
        </Layout>
      </div>
    );
  }

  if (isMobile === null) {
    return (
      <div id="root-portal">
        <Layout title="" page="dashboard">
          <Loader full={true} />
        </Layout>
      </div>
    );
  } else
    return (
      <div id="root-portal">
        {isMobile ? (
          <MobileLayout title="" page="dashboard" wide>
            <MobileCampaignHeader
              id={campaign.id.toString()}
              setId={() => {}}
              home
            />
            <CampaignAssistant campaignId={campaign.id} />
          </MobileLayout>
        ) : (
          <div>
            <Layout title="" page="dashboard">
              <CampaignHeader
                id={campaign.id.toString()}
                setId={() => {}}
                home
              />
            </Layout>
            <CampaignAssistant campaignId={campaign.id} />
          </div>
        )}
      </div>
    );
}
